import { Logo, ToastContainer, FaUserAlt, FaEyeSlash, FaEye, MdErrorOutline, MdLock, AiOutlineLoading3Quarters, overlayStyle, loaderStyle, } from '../../common/common'
import Navigations from '../../common/useNavigation';
import MidForgotPassword from '../../middleware/Authentication/MidForgotPassword'


const ForgotPassword = () => {
    const { navigatePrivacyPolicy,navigateLogin } = Navigations();
    const { handleSubmit, handleChange, values, type, handleToggle, isLoading, isDisabled, navigateprivacypolicy, useErrorContext, navigateRegisterations } = MidForgotPassword();

    const { error } = useErrorContext();
    return (
        <div className='bg-white w-full min-h-screen flex flex-col'>
            <div className='flex-1'>
                <div className='text-center justify-center flex pt-4'>
                    <img src={Logo} width={220} height={70} alt='Logo' className='w-44 md:w-56' />
                </div>
                <div className='max-w-[360px] w-full bg-white my-0 mx-auto p-4 md:p-7' style={{ boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px' }}>
                    <form className="form" onSubmit={handleSubmit}>
                        <div>
                            <label className='text-sm text-label-color font-semibold'>Email Address </label>
                            <div className={`${error.emailnmobi ? 'bg-red-100 border-red-700 mb-0' : ' bg-transparent border-border-color mb-4'} relative p-2 w-full rounded-md mt-2 border-2 active:bg-transparent`}>
                                <FaUserAlt className='text-label-color h-4 w-4 absolute left-3 top-3' />
                                <input
                                    className="bg-transparent ml-6 pl-1 focus:outline-none pr-5 w-[85%] md:w-[90%]"
                                    type="text"
                                    name="emailnmobi"
                                    id="emailnmobi"
                                    autoComplete="new-password"
                                    value={values.emailnmobi}
                                    onChange={handleChange}
                                    placeholder='Enter register email address' />
                                {error.emailnmobi && <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />}
                            </div>
                            {error.emailnmobi && <p className='my-2 px-2 text-red-600 text-xs'>{error.emailnmobi}</p>}
                        </div>
                        <div>
                            <div className="text-right mt-1 mb-4" onClick={navigateLogin}>
                                <span className="text-sm text-blue-600 font-semibold cursor-pointer hover:underline">
                                   Back To Login
                                </span>
                            </div>
                        </div>
                        

                        {(isDisabled === true) ?
                            <button className="cursor-not-allowed opacity-80 relative group m-auto px-8 md:px-12 h-12 md:h-14 text-center rounded-full flex flex-row items-center bg-button-color hover:bg-button-color" disabled>
                                {(isLoading === true) ?
                                    <span className='flex flex-row m-auto text-md font-semibold text-black'>
                                        <AiOutlineLoading3Quarters className='animate-spin h-5 w-5 mr-3' />Processing
                                    </span> :
                                    <span className="relative text-md text-center text-black font-semibold">Send Link</span>
                                }
                                {/* <div className="flex items-center h-10 w-10 md:h-12 md:w-12 rounded-3xl bg-button-color absolute right-[-15px] md:right-[-20px] z-20 drop-shadow-3xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6 stroke-black translate-x-2 md:translate-x-3 transition duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div> */}
                            </button> :
                            <button className="relative group m-auto px-8 md:px-12 h-12 md:h-14 text-center rounded-full flex flex-row items-center bg-button-color hover:bg-button-color">
                                {(isLoading === true) ?
                                    <span className='flex flex-row m-auto text-md font-semibold text-black'>
                                        <AiOutlineLoading3Quarters className='animate-spin h-5 w-5 mr-3' />Processing
                                    </span> :
                                    <span className="relative text-md text-center text-black font-semibold">Send Link </span>
                                }
                                {/* <div className="flex items-center h-10 w-10 md:h-12 md:w-12 rounded-3xl bg-button-color absolute right-[-15px] md:right-[-20px] z-20 drop-shadow-3xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6 stroke-black translate-x-2 md:translate-x-3 transition duration-300 group-hover:translate-x-4 md:group-hover:translate-x-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div> */}
                            </button>
                        }

                        <ToastContainer />
                    </form>
                    <div className='m-3 border-b-[1px] border-solid border-[#e5e5e5]'></div>
                    <div className="text-center mx-0 font-semibold">
                        <p className="py-2 text-sm">Don't Have an Account? <span className="text-blue-600 cursor-pointer text-md font-bold" onClick={navigateRegisterations}>Register Now</span></p>
                    </div>
                    <div className='mx-0 text-center mt-2 text-xs text-[#777575]'>
                        <p className='font-sm font-semibold'>This site is protected by reCAPTCHA and the <span className='text-xs text-blue-500 cursor-pointer' onClick={navigatePrivacyPolicy}>Google Privacy Policy</span> and <span className='text-xs text-blue-500 cursor-pointer'>Terms of Service apply.</span></p>
                    </div>
                </div>
            </div>

            <footer className="w-full bg-white shadow-lg mt-8 py-2">
                <div className="max-w-[1200px] mx-auto p-2">
                    {/* Links Grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2 md:gap-4 text-center">
                        <div><a href="/feature" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Features</a></div>
                        <div><a href="/price" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Price</a></div>
                        <div><a href="/application" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Application</a></div>
                        <div><a href="/blog" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Blogs</a></div>
                        <div><a href="/about" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">About</a></div>
                        <div><a href="/help" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Help</a></div>
                        <div><a href="/documentation" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Documentation</a></div>
                    </div>

                    {/* Copyright Text */}
                    <div className="text-center mt-2">
                        <p className="text-slate-400 text-xs md:text-sm">
                            &copy; Copyright. All rights Reserved {new Date().getFullYear()}
                        </p>
                    </div>
                </div>
            </footer>

            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}
        </div>
    )
}

export default ForgotPassword